import { useContext } from 'react';
import { ApuracaoDePisCofinsContext } from '../contexts/ApuracaoDePisCofinsContext';
import { ApuracaoDePisCofinsContextData } from '../types/context';

export const useApuracaoDePisCofins = (): ApuracaoDePisCofinsContextData =>
  useContext(ApuracaoDePisCofinsContext);
